import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerId } from "apiService/RESTApi";

export const useAllUserCompanyData = () => {
    const [allUserCompanyData, setAllUserCompanyData] = useState([]);

    const allUserCompanyDataFromStore = useSelector((state) => state.SettingReducer.companyData);

    useEffect(() => {
        const filteredCompanyData = allUserCompanyDataFromStore.filter(
            (item) => item?.data?.getCustomerAccount !== null && !item?.errors
        );

        setAllUserCompanyData(filteredCompanyData);
    }, [allUserCompanyDataFromStore]);    

    return allUserCompanyData;
};

/**
 * A wrapper for the store containing company data because the store is not well organized or complete.
 * 
 * @returns {Object} activeCompanyData
 */
export const useActiveCompanyData = () => {
    const [activeCompanyData , setActiveCompanyData] = useState({});

    const activeCompanyDataFromStore = useSelector((state) => state.loginReducer.accountDetails);

    useEffect(() => {
        const getActiveCompanyData = async () => {

            // Prevent errors with undefined data
            if (activeCompanyDataFromStore?.id === ''){
                console.error('Active Company UUID is undefined');
                return;
            }
            const activeCompanyUuid = activeCompanyDataFromStore?.id;

            // Fetch the active company alias
            const response = await getCustomerId(activeCompanyUuid);

            setActiveCompanyData({
                databaseId: response?.response?.data[0]?.customerId,
                uuid: activeCompanyUuid,
                arn: response?.response?.data[0]?.customerArn,
                name: activeCompanyDataFromStore?.company,
                alias: response?.response?.data[0]?.alias,
                dynamoSourceTableName: response?.response?.data[0]?.dynamoSourceTableName,
            });
        }
        getActiveCompanyData();

    }, [activeCompanyDataFromStore]);

    return activeCompanyData;
};